import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zu from './locales/zu.json';
import st from './locales/st.json';
import af from './locales/af.json';
import ts from './locales/ts.json';

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
      zu: { translation: zu },
      st: { translation: st },
      af: { translation: af },
      ts: { translation: ts },
    },
    fallbackLng: 'en', // Fallback language
    lng: localStorage.getItem('preferred_language') || 'en', // Load saved preference
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first, then browser
      caches: ['localStorage'],
    },
  });

export default i18n;
